import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../models';
import { ColumnContextualizer, contextualizeSingleColumnField } from './contextualize-columns.helper';

@Pipe({
  name: 'contextualizeColumn',
  standalone: false,
})
export class ContextualizeColumnPipe implements PipeTransform {
  transform(column: Column, contextualizeWith?: string | ColumnContextualizer): Column {
    return contextualizeSingleColumnField(column, contextualizeWith);
  }
}
